import React from 'react';

import { getColorSwatchStyle } from '../../util/colorSwatches';

import css from './ColorSwatchLabel.module.css';

/**
 * An option label preceded by its colour swatch.
 *
 * Used by both the Colour search filter and the Colour field in the listing
 * wizard, so the two stay visually identical.
 *
 * Falls back to the plain label when the option has no swatch mapping, so a
 * colour added in Console without a mapping still renders readably.
 *
 * @component
 * @param {Object} props
 * @param {string} props.option enum option value from the hosted config
 * @param {React.Node} props.label the option's display label
 * @returns {JSX.Element}
 */
const ColorSwatchLabel = props => {
  const { option, label } = props;
  const swatchStyle = getColorSwatchStyle(option);

  if (!swatchStyle) {
    return <>{label}</>;
  }

  return (
    <span className={css.root}>
      {/* Decorative: the label already names the colour. */}
      <span className={css.swatch} style={swatchStyle} aria-hidden="true" />
      {label}
    </span>
  );
};

export default ColorSwatchLabel;
